export function quoteRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){

    switch(type){
        case "FETCH_QUOTES_START":
            return {
                ...state,
                fetching:true
            }
        case "FETCH_QUOTES_FULFILLED":
            return {
                ...state,
                fetching:false,
                fetched:true,
                error: null
            }
        case "FETCH_QUOTES_ERROR":
            return {
                ...state,
                fetching:false,
                error:payload
            }
        default:
            return state;
    }

}
